import type { UploadSource } from "./network/domain/UploadSource";
import { UploadSourceMapper } from "./network/mappers/UploadSourceMapper";
import { makeObservable, observable } from "mobx";
import type { UploadIndexViewModelModel } from "../../OpenApi/api";

export interface ICurrentUploadSettingsStore {
    readonly sourcesAvailableForUpload: UploadSource[];
    readonly preferredSourceForUpload: UploadSource | null;
    readonly uploadCode: string | null;
    readonly userUploadsWithoutCode: boolean;
}

export class CurrentUploadSettingsStore implements ICurrentUploadSettingsStore {
    @observable
    public readonly sourcesAvailableForUpload: UploadSource[];

    @observable
    public readonly preferredSourceForUpload: UploadSource | null;

    public readonly uploadCode: string | null;

    @observable
    public readonly userUploadsWithoutCode: boolean;

    constructor(uploadViewModel: UploadIndexViewModelModel) {
        const uploadSourceMapper = new UploadSourceMapper();
        this.sourcesAvailableForUpload = uploadViewModel.sourcesAvailableForDicomUpload.map(uploadSourceMapper.map);
        this.preferredSourceForUpload = uploadViewModel.preferredSourceForDicomUpload === null ? null : uploadSourceMapper.map(uploadViewModel.preferredSourceForDicomUpload);
        this.uploadCode = uploadViewModel.uploadCode;
        this.userUploadsWithoutCode = uploadViewModel.userUploadsWithoutCode;

        makeObservable(this);
    }
}
